import { Button } from '@material-ui/core';
import { getCreditCardDetailsById } from '@nemuru-eng/js-api-client';
import { Link, useParams } from 'react-router-dom';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { getPathByApplicationType } from '@/utils/getPathByApplicationType';

import { ApplicationType } from '../../config/types';
import { Font } from '../shared/components/Font';
import { Text } from '../shared/components/Text';

interface OpenApplicationProps {
  application: ApplicationType;
}

export const OpenApplication = (props: OpenApplicationProps) => {
  const { loanId, creditCardId } = useParams();
  const { application } = props;
  const {
    state: { applicationParticipant },
  } = usePageContext();

  const { data: creditCardData } = useCache(getCreditCardDetailsById, creditCardId ? { id: creditCardId } : null);

  const id = application === ApplicationType.CARD && creditCardData ? creditCardData.hppId : loanId;

  if (!id || !applicationParticipant.onboardingDetails?.type) return null;

  const linkTo = getPathByApplicationType({
    applicationType: application,
    id,
    participant: {
      type: applicationParticipant.onboardingDetails?.type,
      role: applicationParticipant.role,
      onboardingDetailsId: applicationParticipant.onboardingDetails?.id,
    },
  });

  return (
    <>
      {linkTo ? (
        <Button>
          <Link to={linkTo} target="_blank" rel="noopener noreferrer">
            <Font variant={'subtitle2'} color={'textSecondary'}>
              <i
                className={'material-icons-outlined mr-2'}
                style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
              >
                open_in_new
              </i>
              <Text tId={'OPEN_APPLICATION'} />
            </Font>
          </Link>
        </Button>
      ) : (
        <></>
      )}
    </>
  );
};
